export default "__VITE_ASSET__BWCGNPbW__"